var map = {
	"./assets/AlertMark.png": "5b01",
	"./assets/DoneMark.png": "e46d",
	"./assets/Help.png": "e4b0",
	"./assets/TruckOff.png": "73b6",
	"./assets/TruckOn.png": "3b8e",
	"./assets/User.png": "0778",
	"./assets/Warehouse.png": "5a16",
	"./assets/bell.png": "6d0d",
	"./assets/calendar.png": "2cc6",
	"./assets/crunchie/BenuaHaulageROT.png": "4ebd",
	"./assets/crunchie/GoldstarHaulageROT.png": "11f4",
	"./assets/crunchie/ROT_ETL.png": "0540",
	"./assets/datetimepickerhelp/1.png": "8102",
	"./assets/datetimepickerhelp/2.png": "7b96",
	"./assets/datetimepickerhelp/3.png": "b7b3",
	"./assets/datetimepickerhelp/4.png": "a581",
	"./assets/designer/AlignTextBottom.png": "2aae",
	"./assets/designer/AlignTextMiddle.png": "a8f9",
	"./assets/designer/AlignTextTop.png": "e115",
	"./assets/designer/BoldText.png": "8cc6",
	"./assets/designer/CenterTextAlign.png": "84dd",
	"./assets/designer/InheritTextAlign.svg": "7b39",
	"./assets/designer/ItalicText.png": "ef2b",
	"./assets/designer/JustifyTextAlign.png": "915c",
	"./assets/designer/LeftTextAlign.png": "abec",
	"./assets/designer/RightTextAlign.png": "41cb",
	"./assets/designer/UnderlineText.png": "e72e",
	"./assets/dsm.png": "182b",
	"./assets/foldericon.png": "b493",
	"./assets/leftmenuicons/Fin.png": "8f61",
	"./assets/leftmenuicons/Log.png": "844f",
	"./assets/leftmenuicons/Tra.png": "58da",
	"./assets/leftmenuicons/Uti.png": "3545",
	"./assets/logo.png": "cf05",
	"./assets/mapControlIcons/bluedot.png": "244e",
	"./assets/mapControlIcons/clearmarker.png": "391b",
	"./assets/mapControlIcons/collapse.png": "8b55",
	"./assets/mapControlIcons/disable.png": "95b6",
	"./assets/mapControlIcons/expand.png": "3e59",
	"./assets/mapControlIcons/help.png": "c5bd",
	"./assets/mapControlIcons/hidegeofence.png": "4a13",
	"./assets/mapControlIcons/hybridMap.png": "d222",
	"./assets/mapControlIcons/mapGuide/hovering.gif": "804d",
	"./assets/mapControlIcons/mapGuide/marker.gif": "dd26",
	"./assets/mapControlIcons/mapGuide/menu.gif": "dfb6",
	"./assets/mapControlIcons/mapGuide/rightclick.gif": "3319",
	"./assets/mapControlIcons/marker.png": "dfb0",
	"./assets/mapControlIcons/menu.png": "265b",
	"./assets/mapControlIcons/menuclose.png": "19c2",
	"./assets/mapControlIcons/mylocation.png": "5b10",
	"./assets/mapControlIcons/roadmapMap.png": "e465",
	"./assets/mapControlIcons/showgeofence.jpg": "95f3",
	"./assets/mapControlIcons/zoomin.png": "704b",
	"./assets/mapControlIcons/zoomout.png": "a7c6",
	"./assets/pencil.png": "5a11",
	"./assets/tag.png": "f47b",
	"./assets/testimage/image1.jpg": "2c00",
	"./assets/testimage/image2.jpg": "79d8",
	"./assets/testimage/image3.jpg": "605f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";